import React from 'react'
import { BreadcrumbView } from '../../../../../context/breadcrumb.context'
import { IconList } from '../../../../../shared/icon/icon'
import { Menu, MenuPurge, MenuRestore } from '../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../shared/card/card-full-height-scroll-y'
import { useApiListLogin } from '../../../../../api-new/state/content'
import { useRoleSysLogin } from '../../../../../role/hook/role-sys'
import { TableAgClient } from '../../../../../shared/table-builder/table-ag-client'
import { ColumnMenu, ColumnText } from '../../../../../shared/table-builder/table-columns'
import { recycleErrorMessage } from '../../../../../shared/error/server-message'
import { ErrorReference } from '../../../../../shared/error/error-reference'
import { useErrorLine } from '../../../../../shared/error/use-error-line'

export function LoginRecycle() {
  const apiListLogin = useApiListLogin()

  const roleSysLogin = useRoleSysLogin()

  const [error, failure, setError] = useErrorLine()

  const handleReady = async () => await apiListLogin.get('deleted')
  const handleDestroyed = () => apiListLogin.init()

  const handleRestore = async item => {
    setError(null)
    try {
      await apiListLogin.put(`${item.id}/restore`)
    } catch (err) {
      setError(recycleErrorMessage(err, 'That login was already removed.'), err)
    }
    await apiListLogin.get('deleted')
  }

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Recycle bin">
        <CardFullHeightScrollY title="recycle bin">
          {error &&
            <p className="text-danger" role="alert">
              {error}
            </p>}
          {error && <ErrorReference error={failure} className="mb-3" />}
          <TableAgClient apiList={apiListLogin} onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="email" />
            <ColumnText field="firstName" />
            <ColumnText field="lastName" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRestore onClick={() => handleRestore(row)} show={roleSysLogin.accessDelete} />
                  <MenuPurge to={`/admin/login/list/recycle/purge/${row.id}`} show={roleSysLogin.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
